import React, { useMemo, useState, useEffect } from 'react'
import { useDispatch, useSelector, shallowEqual } from 'react-redux'
import {
  searchBusinessEntities,
  searchTrademarkEntities,
  searchUCCEntities,
  searchNotary,
  searchRegisteredAgents,
  searchAthleteAgent,
  searchCharity,
  searchContractor,
  searchLobbyist,
  searchEntities,
} from './PaperModalActions'
import { ContextButton } from '@tecuity/granite-ui/ContextButton'
import { SearchBox } from '@tecuity/granite-ui/SearchBox'
import { Spinner } from 'components/Loaders/Loaders'
import '../WorkviewManager.scss'
import { SelectBox } from '@tecuity/granite-ui'
import { FormSelectionIcon } from './FormSelectionList'
import {
  defaultRecordSearchQuery,
  SET_RECORD_TO_AMEND,
  SET_RECORD_SEARCH_QUERY,
  SET_SEARCH_RESULTS,
} from '../../WVManager/Workview2Reducer'
import { useHistory } from 'react-router'
import { FilingSourceTypeIds } from '../../../Utilities/Utilities'

export const USE_ENTITY_FRAMEWORK = process.env.USE_ENTITY_FRAMEWORK

const EntitySelectionList = (props) => {
  const { triggerClear, setTriggerClear } = props
  const history = useHistory()
  const dispatch = useDispatch()
  const {
    recordSearchQuery,
    selectedRow,
    searchResults,
    staffDraft,
    orderDetails,
    legacyFilingDetails,
  } = useSelector((state) => state.workview2, shallowEqual)
  const [hasSearchBeenMade, setHasSearchBeenMade] = useState(false)
  const [showSpinner, setShowSpinner] = useState(false)

  useEffect(() => {
    if (triggerClear) {
      clickClear()
      setTriggerClear(false)
    }
  }, [triggerClear])

  const clickClear = () => {
    dispatch({
      type: SET_RECORD_SEARCH_QUERY,
      query: defaultRecordSearchQuery,
    })
    dispatch({
      type: SET_SEARCH_RESULTS,
      results: [],
    })
    setHasSearchBeenMade(false)
  }

  const search = useMemo(() => {
    let search = null
    if (
      selectedRow.SourceTypeId === FilingSourceTypeIds.Trademark ||
      (selectedRow.SourceTypeId === FilingSourceTypeIds.Orders &&
        orderDetails &&
        orderDetails.SourceTypeId === FilingSourceTypeIds.Trademark) ||
      (selectedRow.SourceTypeId === FilingSourceTypeIds.Legacy &&
        legacyFilingDetails &&
        legacyFilingDetails.SourceTypeId === FilingSourceTypeIds.Trademark)
    ) {
      search = searchTrademarkEntities
    } else if (
      selectedRow.SourceTypeId === FilingSourceTypeIds.Lien ||
      (selectedRow.SourceTypeId === FilingSourceTypeIds.Orders &&
        orderDetails &&
        orderDetails.SourceTypeId === FilingSourceTypeIds.Lien)
    ) {
      search = searchUCCEntities
    } else if (selectedRow.SourceTypeId === FilingSourceTypeIds.Notary) {
      search = searchNotary
    } else if (selectedRow.SourceTypeId === FilingSourceTypeIds.RegisteredAgent) {
      search = searchRegisteredAgents
    } else if (selectedRow.SourceTypeId === FilingSourceTypeIds.AthleteAgent) {
      search = searchAthleteAgent
    } else if (
      selectedRow.SourceTypeId === FilingSourceTypeIds.Business ||
      (selectedRow.SourceTypeId === FilingSourceTypeIds.Orders &&
        orderDetails &&
        orderDetails.SourceTypeId === FilingSourceTypeIds.Business) ||
      (selectedRow.SourceTypeId === FilingSourceTypeIds.Legacy &&
        legacyFilingDetails &&
        legacyFilingDetails.SourceTypeId === FilingSourceTypeIds.Business)
    ) {
      search = searchBusinessEntities
    } else if (selectedRow.SourceTypeId === FilingSourceTypeIds.Orders &&
        orderDetails &&
        orderDetails.SourceTypeId === FilingSourceTypeIds.Charity) {
      search = searchCharity
    } else if (selectedRow.SourceTypeId === FilingSourceTypeIds.Orders &&
        orderDetails &&
        orderDetails.SourceTypeId === FilingSourceTypeIds.Contractor) {
      search = searchContractor
    } else if (selectedRow.SourceTypeId === FilingSourceTypeIds.Orders &&
        orderDetails &&
        orderDetails.SourceTypeId === FilingSourceTypeIds.Lobbyist) {
      search = searchLobbyist
    }else {
      search = searchEntities
    }
    return search
  }, [selectedRow, orderDetails])

  const nameSearchPlaceholder = useMemo(() => {
    if (
      selectedRow.SourceTypeId === FilingSourceTypeIds.Trademark ||
      (selectedRow.SourceTypeId === FilingSourceTypeIds.Orders &&
        orderDetails &&
        orderDetails.SourceTypeId === FilingSourceTypeIds.Trademark) ||
      (selectedRow.SourceTypeId === FilingSourceTypeIds.Legacy &&
        legacyFilingDetails &&
        legacyFilingDetails.SourceTypeId === FilingSourceTypeIds.Trademark)
    ) {
      return 'Trademark Name'
    } else if (
      selectedRow.SourceTypeId === FilingSourceTypeIds.Lien ||
      (selectedRow.SourceTypeId === FilingSourceTypeIds.Orders &&
        orderDetails &&
        orderDetails.SourceTypeId === FilingSourceTypeIds.Lien)
    ) {
      return 'Submitter Name'
    } else if (selectedRow.SourceTypeId === FilingSourceTypeIds.Notary) {
      return 'Notary Name'
    } else {
      return 'Name'
    }
  }, [selectedRow, orderDetails])

  const selectTypeName = useMemo(() => {
    if (
      selectedRow.SourceTypeId === FilingSourceTypeIds.Trademark ||
      (selectedRow.SourceTypeId === FilingSourceTypeIds.Orders &&
        orderDetails &&
        orderDetails.SourceTypeId === FilingSourceTypeIds.Trademark) ||
      (selectedRow.SourceTypeId === FilingSourceTypeIds.Legacy &&
        legacyFilingDetails &&
        legacyFilingDetails.SourceTypeId === FilingSourceTypeIds.Trademark)
    ) {
      return 'Trademark'
    } else if (
      selectedRow.SourceTypeId === FilingSourceTypeIds.Lien ||
      (selectedRow.SourceTypeId === FilingSourceTypeIds.Orders &&
        orderDetails &&
        orderDetails.SourceTypeId === FilingSourceTypeIds.Lien)
    ) {
      return 'Lien'
    } else if (selectedRow.SourceTypeId === FilingSourceTypeIds.Notary) {
      return 'Notary'
    } else if (selectedRow.SourceTypeId === FilingSourceTypeIds.RegisteredAgent) {
      return 'Agent'
    } else if (selectedRow.SourceTypeId === FilingSourceTypeIds.AthleteAgent) {
      return 'Athlete Agent'
    } else {
      return 'Entity'
    }
  }, [selectedRow, orderDetails])

  const fileNumberPlaceholder = useMemo(() => {
    if (
      selectedRow.SourceTypeId === FilingSourceTypeIds.Trademark ||
      (selectedRow.SourceTypeId === FilingSourceTypeIds.Orders &&
        orderDetails &&
        orderDetails.SourceTypeId === FilingSourceTypeIds.Trademark) ||
      (selectedRow.SourceTypeId === FilingSourceTypeIds.Legacy &&
        legacyFilingDetails &&
        legacyFilingDetails.SourceTypeId === FilingSourceTypeIds.Trademark)
    ) {
      return 'Trademark #'
    } else if (
      selectedRow.SourceTypeId === FilingSourceTypeIds.Lien ||
      (selectedRow.SourceTypeId === FilingSourceTypeIds.Orders &&
        orderDetails &&
        orderDetails.SourceTypeId === FilingSourceTypeIds.Lien)
    ) {
      return 'UCC Doc #'
    } else if (selectedRow.SourceTypeId === FilingSourceTypeIds.Notary) {
      return 'Commission #'
    } else if (selectedRow.SourceTypeId === FilingSourceTypeIds.AthleteAgent) {
      return 'License #'
    } else {
      return 'File #'
    }
  }, [selectedRow, orderDetails])

  const getResult = (selectedRow, item) => {
    return selectedRow.SourceTypeId === FilingSourceTypeIds.Lien ||
      (selectedRow.SourceTypeId === FilingSourceTypeIds.Orders &&
        orderDetails &&
        orderDetails.SourceTypeId === FilingSourceTypeIds.Lien) ? (
      <LienResult item={item} />
    ) : selectedRow.SourceTypeId === FilingSourceTypeIds.Notary ? (
      <NotaryResult item={item} />
    ) : selectedRow.SourceTypeId === FilingSourceTypeIds.Trademark ||
      (selectedRow.SourceTypeId === FilingSourceTypeIds.Orders &&
        orderDetails &&
        orderDetails.SourceTypeId === FilingSourceTypeIds.Trademark) ||
      (selectedRow.SourceTypeId === FilingSourceTypeIds.Legacy &&
        legacyFilingDetails &&
        legacyFilingDetails.SourceTypeId === FilingSourceTypeIds.Trademark) ? (
      <TrademarkResult item={item} />
    ) : selectedRow.SourceTypeId === FilingSourceTypeIds.RegisteredAgent ? (
      <AgentResult item={item} />
    ) : selectedRow.SourceTypeId === FilingSourceTypeIds.AthleteAgent ? (
      <AthleteAgentResult item={item} />
    ) : (selectedRow.SourceTypeId === FilingSourceTypeIds.Orders &&
        orderDetails &&
        orderDetails.SourceTypeId === FilingSourceTypeIds.Charity) ? (
      <CharityResult item={item} />
    ) : (selectedRow.SourceTypeId === FilingSourceTypeIds.Orders &&
        orderDetails &&
        orderDetails.SourceTypeId === FilingSourceTypeIds.Contractor) ? (
      <ContractorResult item={item} />
    ) : (selectedRow.SourceTypeId === FilingSourceTypeIds.Orders &&
        orderDetails &&
        orderDetails.SourceTypeId === FilingSourceTypeIds.Lobbyist) ? (
      <LobbyistResult item={item} />
    ) : selectedRow.SourceTypeId === FilingSourceTypeIds.Charity ||
        selectedRow.SourceTypeId === FilingSourceTypeIds.Lobbyist || 
        selectedRow.SourceTypeId === FilingSourceTypeIds.Contractor ? ( // Add new modules to this rather than creating new component types each time.
      <GenericResult item={item} />
    ) : (
      <BusinessResult item={item} />
    )
  }

  useEffect(() => {
    setShowSpinner(false)
  }, [searchResults])

  const staffSearchOptions = [
    { value: '1', label: 'Begins With' },
    { value: '2', label: 'Contains' },
    { value: '3', label: 'Exact' },
  ]

  const searchBySearchValue = (value = null, number = null) => {
    let searchQuery = { ...recordSearchQuery }

    if (
      selectedRow.SourceTypeId === FilingSourceTypeIds.Lien ||
      (selectedRow.SourceTypeId === FilingSourceTypeIds.Orders &&
        orderDetails &&
        orderDetails.SourceTypeId === FilingSourceTypeIds.Lien)
    ) {
      delete searchQuery.SearchName
      delete searchQuery.Description
      if (value !== null) {
        searchQuery.SubmitterName = value
      }

      delete searchQuery.CommissionNum
      delete searchQuery.FileNumber
      delete searchQuery.Number
      if (number !== null) {
        searchQuery.FilingNum = number
      }
    } else if (
      selectedRow.SourceTypeId === FilingSourceTypeIds.Trademark ||
      (selectedRow.SourceTypeId === FilingSourceTypeIds.Orders &&
        orderDetails &&
        orderDetails.SourceTypeId === FilingSourceTypeIds.Trademark) ||
      (selectedRow.SourceTypeId === FilingSourceTypeIds.Legacy &&
        legacyFilingDetails &&
        legacyFilingDetails.SourceTypeId === FilingSourceTypeIds.Trademark)
    ) {
      delete searchQuery.SearchName
      delete searchQuery.SubmitterName
      if (value !== null) {
        searchQuery.Description = value
      }

      delete searchQuery.CommissionNum
      delete searchQuery.FileNumber
      delete searchQuery.FilingNum
      if (number !== null) {
        searchQuery.TrademarkNumber = number
      }
    } else {
      delete searchQuery.SubmitterName
      delete searchQuery.Description
      if (value !== null) {
        searchQuery.SearchName = value
      }

      if (selectedRow.SourceTypeId === FilingSourceTypeIds.Notary) {
        delete searchQuery.CommissionNum
        delete searchQuery.FilingNum
        delete searchQuery.Number
        if (number !== null) {
          searchQuery.CommissionNum = number
        }
      } else if (selectedRow.SourceTypeId === FilingSourceTypeIds.RegisteredAgent) {
        delete searchQuery.FileNumber
        delete searchQuery.CommissionNum
        delete searchQuery.Number
        if (number !== null) {
          searchQuery.FilingNum = number
        }
      } else if (selectedRow.SourceTypeId === FilingSourceTypeIds.Charity ||
        selectedRow.SourceTypeId === FilingSourceTypeIds.Lobbyist || 
        selectedRow.SourceTypeId === FilingSourceTypeIds.Contractor
      ) { 
        // Add new modules to this rather than creating new component types each time.
        // These fields are needed for the generic SearchEntities method.
        searchQuery = {
          QueryTypeId: recordSearchQuery.QueryTypeId,
          SearchName: value,
          RecordNum: number,
          SourceTypeId: selectedRow.SourceTypeId
        }
      } else {
        delete searchQuery.FilingNum
        delete searchQuery.CommissionNum
        delete searchQuery.Number
        if (number !== null) {
          searchQuery.FileNumber = number
        }
      }
    }

    dispatch(search(searchQuery))
  }

  const secondaryReview = useMemo(() => {
    // if a paper filed WVItem has a filingNum and a formDefinitionId,
    // then it must have come back from secondary review.
    if (selectedRow.Filing.Num && selectedRow.FormDefinitionId) {
      return {
        FilingNum: selectedRow.Filing.Num,
        FormDefinitionId: selectedRow.FormDefinitionId,
        ImagePageType: selectedRow.ResourceImagePageType,
      }
    } else return null
  }, [selectedRow])

  return (
    <div>
      {staffDraft && (
        <React.Fragment>
          <h2>Continue working from draft</h2>
          <div className="form-blocks paper-processed-wizard-item-wrapper">
            <FormSelectionIcon
              staffDraft
              formName={staffDraft.FormTitle}
              value={staffDraft.FormDefinitionId}
              selectedRow={selectedRow}
              form={{
                FormDefinitionID: staffDraft.FormDefinitionId,
                FormTitle: staffDraft.FormTitle,
                filingTypeID: staffDraft.FilingTypeId,
                amendmentTypeID: staffDraft.AmendmentTypeId,
                IsInitialFiling: !!staffDraft.AmendmentTypeId,
              }}
            />
          </div>
        </React.Fragment>
      )}
      {secondaryReview && (
        <React.Fragment>
          <h2>Review Debtors/Secured Parties</h2>
          <div className="form-blocks paper-processed-wizard-item-wrapper">
            <FormSelectionIcon
              staffDraft
              formName={secondaryReview.ImagePageType}
              value={secondaryReview.FormDefinitionId}
              selectedRow={selectedRow}
              processInitialFiling={() => {
                // reopen wizard with filing info
                history.push(
                  `/office/workview/process/${secondaryReview.FormDefinitionId}/${secondaryReview.FilingNum}?staffEntryRequired=true`
                )
              }}
            />
          </div>
        </React.Fragment>
      )}
      <div style={{ margin: '5px', padding: '15px' }}>
        <h2>Select {selectTypeName}</h2>
        <div className="filingSelectButtonWrapper">
          <SearchBox
            placeholder={nameSearchPlaceholder}
            value={recordSearchQuery.SearchName || ''}
            onChange={(e) =>
              dispatch({
                type: SET_RECORD_SEARCH_QUERY,
                query: {
                  ...recordSearchQuery,
                  SearchName: e,
                  SubmitterName: e,
                  TrademarkName: e,
                },
              })
            }
            showClearButton={false}
            showSearchButton={false}
            onSubmit={(value, e) => {
              searchBySearchValue(value)
            }}
          />
          <SearchBox
            placeholder={fileNumberPlaceholder}
            value={recordSearchQuery.FileNumber || ''}
            onChange={(e) =>
              dispatch({
                type: SET_RECORD_SEARCH_QUERY,
                query: {
                  ...recordSearchQuery,
                  FileNumber: e,
                  FilingNum: e,
                  Number: e,
                  CommissionNum: e,
                },
              })
            }
            showClearButton={false}
            showSearchButton={false}
            onSubmit={(value, e) => {
              searchBySearchValue(null, value)
            }}
          />
          <SelectBox
            options={staffSearchOptions}
            value={recordSearchQuery.QueryTypeID} // default to Begins With.
            onChange={(value) => {
              dispatch({
                type: SET_RECORD_SEARCH_QUERY,
                query: {
                  ...recordSearchQuery,
                  QueryTypeID: value,
                  QueryTypeId: value,
                  SearchMethodID: value,
                  Method: value,
                },
              })
            }}
            customCss={{ select: { height: '40px', marginTop: '4px' } }}
            aria-label="Search Type"
          />
          <div elevation="standard" className="search-bar">
            <ContextButton variant="danger" onClick={clickClear} customCss={''}>
              Clear
            </ContextButton>
            <ContextButton
              variant="primary"
              onClick={() => {
                searchBySearchValue(
                  recordSearchQuery.SearchName || null,
                  recordSearchQuery.FileNumber || null
                )
                setShowSpinner(true)
                setHasSearchBeenMade(true)
              }}
              customCss={''}
            >
              Search
            </ContextButton>
          </div>
        </div>
      </div>
      {searchResults.length === 0 && !showSpinner && (
        <div
          style={{
            textAlign: 'center',
            width: '100%',
            marginTop: '7.5em',
            marginBottom: '7.5em',
          }}
        >
          <h1 style={{ padding: '15px', fontWeight: 'bold' }}>
            {hasSearchBeenMade
              ? `No Records Found - Please Refine Search`
              : `Please Search for ${
                  selectTypeName === 'Entity' ||
                  selectTypeName === 'Athlete Agent' ||
                  selectTypeName === 'Agent'
                    ? `an`
                    : `a`
                } ${selectTypeName} to Amend`}
          </h1>
        </div>
      )}
      {showSpinner && (
        <div
          style={{
            height: '200px',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
          className="form-blocks"
        >
          <div>
            <Spinner className="page-loader" themeColor="neutral" />
          </div>
        </div>
      )}
      <div>
        <div className="search-wrapper paper-process-result-wrapper">
          {searchResults.length > 0 &&
            !showSpinner &&
            searchResults.map((item, i) => {
              return (
                <div
                  key={i}
                  className="stacked-data-result paper-process-result-item"
                  type="button"
                  onClick={() => {
                    dispatch({ type: SET_RECORD_TO_AMEND, record: item })
                  }}
                >
                  <div className="row">{getResult(selectedRow, item)}</div>
                </div>
              )
            })}
        </div>
      </div>
    </div>
  )
}

export default EntitySelectionList

const LienResult = ({ item }) => {
  return (
    <div className="search-result">
      <span className="primary">{item['Filing #']}</span>
      {item.Debtor && <span className="secondary">Debtor: {item.Debtor}</span>}
      <span className="secondary">Status: {item['Name Status'] || item.Status}</span>
    </div>
  )
}

const NotaryResult = ({ item }) => {
  const redFlagStatus = useMemo(() => {
    if (typeof item.Status === 'object') return item.Status.RedFlagStatus
    return false
  }, [item])

  const status = useMemo(() => {
    if (item['Name Status']) return item['Name Status']
    if (typeof item.Status === 'object') return item.Status.Description
    return item.Status
  }, [item])

  return (
    <div className="search-result">
      <span className="primary">{item['Notary Name']}</span>
      <span className="secondary">Commission #: {item['Commission Number']}</span>
      <span className={`secondary red-flag-status-cell ${redFlagStatus ? 'alert' : ''}`}>
        Status: {status}
      </span>
    </div>
  )
}

const GenericResult = ({ item }) => {
  return (
    <div className="search-result">
      {Object.keys(item).map(key => {
        // SourceID is a special key needed after the entity is selected, but it shouldn't be displayed.
        if (item[key] && item[key] !== '' && key !== 'SourceID') {
          return key === 'Name' ? 
            <span className='primary'>{item[key]}</span> :
            <span className='secondary'>{key}: {item[key]}</span>
        }

        return null
      })}
    </div>
  )
}

const BusinessResult = ({ item }) => {
  return (
    <div className="search-result">
      <span className="primary">{item['Name']}</span>
      <span className="secondary">
        {item['Filing Number'] ? 'Filing #: ' : 'Record #: '}
        {item['Filing Number'] || item['Record Number']}
      </span>
      <span className="secondary">Type: {item['Record Type']}</span>
      {item['Record Sub-Type'] && item['Record Sub-Type'] !== '' ? (
        <span className="secondary">Sub-Type: {item['Record Sub-Type']}</span>
      ) : null}
    </div>
  )
}

const AgentResult = ({ item }) => {
  return (
    <div className="search-result">
      <span className="primary">{item['Name']}</span>
      <span className="secondary">Agent #: {item['File #']}</span>
      <span className="secondary">Type: {item['Type']}</span>
      <span className="secondary">Status: {item['Status'] || item.Status}</span>
    </div>
  )
}

export const TrademarkResult = ({ item }) => {
  return (
    <div className="search-result">
      <span className="primary">{item['Trademark Name'] || item['Name']}</span>
      <span className="secondary">Trademark Description: {item['Trademark Description']}</span>
      <span className="secondary">
        {item['Trademark #'] ? 'Trademark #: ' : 'Record Number: '}
        {item['Trademark #'] || item['Record Number']}
      </span>
      <span className="secondary">Status: {item['Name Status'] || item.Status}</span>
    </div>
  )
}

const AthleteAgentResult = ({ item }) => {
  return (
    <div className="search-result">
      <span className="primary">
        {item['First Name']} {item['Last Name']}
      </span>
      <span className="secondary">License #: {item['License #']}</span>
      <span className="secondary">Agency: {item['Agency Name']}</span>
    </div>
  )
}

const CharityResult = ({ item }) => {
  return (
    <div className="search-result">
      <span className="primary">{item['Name']}</span>
      <span className="secondary">Record #: {item['Record #']}</span>
      <span className="secondary">Status: {item['Status'] || item.Status}</span>
    </div>
  )
}

const ContractorResult = ({ item }) => {
  return (
    <div className="search-result">
      <span className="primary">{item['Name']}</span>
      <span className="secondary">Record #: {item['Record #']}</span>
      <span className="secondary">Status: {item['Status'] || item.Status}</span>
    </div>
  )
}

const LobbyistResult = ({ item }) => {
  return (
    <div className="search-result">
      <span className="primary">{item['Name']}</span>
      <span className="secondary">Registration #: {item['Registration #']}</span>
      <span className="secondary">Status: {item['Status'] || item.Status}</span>
    </div>
  )
}
